var map = {
	"./HomePage.palestine": [
		11337,
		[
			337
		]
	],
	"./HomePage.palestine.tsx": [
		11337,
		[
			337
		]
	],
	"./HomePage.syr-gos": [
		18096,
		[
			96
		]
	],
	"./HomePage.syr-gos.tsx": [
		18096,
		[
			96
		]
	],
	"./HomePage.ukraine": [
		11239,
		[
			239
		]
	],
	"./HomePage.ukraine.tsx": [
		11239,
		[
			239
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 70490;
module.exports = webpackAsyncContext;